import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import SessionStorageService from '@ion/user/SessionStorageService';
import { auth0Config } from './auth0';
import propTypes from 'prop-types';
import { routes } from '../constants';
import buildRedirectUri from './buildRedirectUri';

const auth0Domain = auth0Config.domain();
const auth0ClientID = auth0Config.clientID();

const redirectUri = buildRedirectUri(routes.loginRedirect);

function MrAuth0Provider({ children }) {
  const orgId = SessionStorageService.getInitialSessionOrgId();

  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientID}
      redirectUri={redirectUri}
      useRefreshTokens={true}
      {...(orgId && { organization: orgId })}
      cacheLocation="memory"
    >
      {children}
    </Auth0Provider>
  );
}

MrAuth0Provider.propTypes = {
  children: propTypes.node,
};

export default MrAuth0Provider;
